export const CUSTOMER_ORDERS_PAGE_SELECTED_QUERY_KEY = "selected";
export const CUSTOMER_ORDERS_PAGE_SEARCH_QUERY_KEY = "search";
export const CUSTOMER_ORDERS_DETAIL_PAGE_SEARCH_QUERY_KEY = "detail-search";
export const CUSTOMER_ORDERS_DETAIL_PAGE_SHOW_UNCONFIRMED_QUERY_KEY = "show-unconfirmed";
export const CUSTOMER_ORDERS_PAGE_PERIOD_QUERY_KEY = "period";
